<template>
  <app-dialog color="green">
    <template v-slot:dialogTitle>
      <receipt-icn
        class="green-icon ml-5 mr-2"
        width="20px"
        height="20px"
        fill-rule="evenodd"
      ></receipt-icn>
      <span class="text-green text-lg font-bold">領収書</span>
    </template>

    <template v-slot:dialogContent>
      <TabGroup :defaultIndex="0">
        <TabList class="flex space-x-1 fixed" style="right: 54px; top: 10px;">
          <Tab v-slot="{ selected }">
            <!-- 領収書 -->
            <AppReceiptStatusButton
              :status="currentReceipt.option.viewType"
              :class="[
                'border-4 border-green text-green w-40 h-10 tab-button pl-1',
                selected ? 'tab-active' : 'border-dotted',
              ]"
              ><template v-slot:buttonText>
                <span class="ml-3 text-green text-lg font-bold">領</span>
                <span class="text-green text-sm font-bold">収書</span>
              </template>
            </AppReceiptStatusButton>
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <ReceiptOffice
              class="ml-2 mt-1"
              v-if="
                receiptDialog.isOffice == false &&
                  currentUser.role.rank == 10 &&
                  currentUser.role.is_authorizer &&
                  currentReceipt.option.viewType == 2
              "
              style="max-height: 450px; overflow-y: scroll;"
            />
            <ReceiptOffice
              class="ml-2 mt-1"
              v-else-if="
                receiptDialog.isOffice == false &&
                  currentUser.role.rank == 2 &&
                  currentUser.role.is_authorizer &&
                  (currentReceipt.option.viewType == 2 ||
                    currentReceipt.option.viewType == 3)
              "
              style="max-height: 450px; overflow-y: scroll;"
            />

            <ReceiptPreview
              class="ml-2 mr-2"
              v-else-if="
                receiptDialog.isPreview ||
                  (currentUser.role.rank !== 1 &&
                    currentReceipt.option.viewType == 1) ||
                  (currentUser.role.rank !== 1 &&
                    currentReceipt.option.viewType == 4) ||
                  (currentUser.role.rank !== 1 &&
                    currentReceipt.option.viewType == 5) ||
                  (currentUser.role.rank !== 1 &&
                    currentReceipt.option.viewType == 6) ||
                  (currentUser.role.rank !== 1 &&
                    currentReceipt.option.viewType == 7) ||
                  (currentUser.role.rank == 1 &&
                    currentReceipt.option.viewType == 4) ||
                  (currentUser.role.rank == 1 &&
                    currentReceipt.option.viewType == 6)
              "
              style="max-height: 450px; overflow-y: scroll;"
            ></ReceiptPreview>
            <ReceiptFormNavigation class="mr-8 mt-6" v-else>
              <template v-slot:tabContent>
                <receipt-form />
              </template>
              ></ReceiptFormNavigation
            >
          </TabPanel>
        </TabPanels>
      </TabGroup>
    </template>
    <template v-slot:dialogFooterActions>
      <user-circle-icn width="40px" height="40px" class="ml-1" />
      <span class="text-white ml-1 leading-tight">
        {{ currentReceipt.user.uname }}
        <br />
        {{ dayjs(currentReceipt.createdAt).format('YYYY/M/D') }}作成
      </span>
      <div
        class="mr-1"
        :style="
          currentUser.role.is_authorizer
            ? 'position: absolute; left: 188px;'
            : 'margin-left:auto'
        "
      >
        <!-- 会派とりまとめ、事務局表示 -->
        <!--  viewType
        - 1:作成中
        - 2:自分の確認待ち
        - 3:自分の再確認待ち
        - 4:承認ずみ
        - 5:自分は確認時み
        - 6:自分以外の確認待ち
        - 7:自分以外の再確認対応待ち
       -->
        <div v-if="currentUser.role.is_authorizer">
          <!-- 差し戻し、対応待ち -->
          <div
            v-if="
              currentReceipt.option.viewType === 2 ||
                currentReceipt.option.viewType === 3
            "
            class="flex items-center"
          >
            <AppReceiptShowFormBtn
              v-if="!receiptDialog.isPreview"
              @click="receiptDialog.isOffice = true"
              :disabled="receiptDialog.isOffice"
              :hidden="currentUser.role.rank !== 2"
              color="green"
            />
            <AppShowPreviewBtn
              :style="
                currentUser.role.rank !== 2
                  ? 'width: 680px; margin-left: 4px;'
                  : 'width: 320px; margin-left: 4px;'
              "
              color="green"
              colorcode="#549A1D"
              @click="showPreview(true)"
              v-if="!receiptDialog.isPreview"
              :disabled="receiptDialog.isOffice"
            />

            <AppRejectBtn
              v-if="receiptDialog.isPreview"
              color="green"
              @click="submitReject(currentReceipt.id)"
              docType="receipt"
              :disabled="rejectedAttrs.length === 0"
            />
            <!-- 自分の承認待ちの時または、差戻し依頼が来ている会派事務局の時に承認ボタンを表示する -->
            <AppApproveBtn
              v-if="
                receiptDialog.isPreview &&
                  (currentReceipt.option.viewType === 2 ||
                    currentReceipt.option.viewType === 3)
              "
              color="green"
              @click="approveRequest(currentReceipt.id, currentUser.role.rank)"
              docType="receipt"
            />
            <AppShowOfficeBtn
              color="green"
              @click="showPreview(false)"
              :hidden="!receiptDialog.isOffice"
            />
          </div>
          <!-- 承認済み -->
          <div
            v-if="currentReceipt.option.viewType == 4"
            class="flex items-center"
          >
            <AppApprovedBtn color="green" />
          </div>
          <div
            v-if="currentReceipt.option.viewType == 5"
            class="flex items-center"
          >
            <AppApproveStateBtn
              color="green"
              :count="currentReceipt.option.current"
              :totalApprove="currentReceipt.option.total"
            />
          </div>
          <!-- 承認待ち -->
          <div
            v-if="currentReceipt.option.viewType == 6"
            class="flex items-center"
          >
            <AppWaitingBtn
              color="green"
              :isAuthorizer="currentUser.role.is_authorizer"
              :count="currentReceipt.option.current"
              :total="currentReceipt.option.total"
            />
          </div>
          <!-- 再確認待ち -->
          <div
            v-if="currentReceipt.option.viewType == 7"
            class="flex items-center"
          >
            <AppRejectDisabledBtn
              color="green"
              :approveStatus="currentReceipt.option.viewType"
            />
          </div>
        </div>

        <!-- 議員表示 -->
        <div v-else>
          <!-- 承認待ち -->
          <div
            v-if="currentReceipt.option.viewType == 6"
            class="flex items-center"
          >
            <AppWaitingBtn
              color="green"
              :isAuthorizer="currentUser.role.is_authorizer"
              :count="currentReceipt.option.current"
              :totalApprove="currentReceipt.option.total"
            />
            <AppCancelBtn
              color="green"
              @click="cancelRequest(currentReceipt.id)"
            />
          </div>
          <!-- 承認済み -->
          <div
            v-if="currentReceipt.option.viewType == 4"
            class="flex items-center"
          >
            <AppApprovedBtn color="green" />
            <AppCancelBtn color="green" disabled />
          </div>

          <div v-else>
            <!-- 議員プレビュー -->
            <div v-if="receiptDialog.isPreview" class="flex items-center">
              <AppApplyBtn
                color="green"
                @click="
                  submitReceipt(
                    currentReceipt.id ? currentReceipt.id : null,
                    'receipt-apply',
                  )
                "
                form="receiptForm"
                type="submit"
              />
              <button
                class="box-border h-10 bg-white border-4 border-green disabled:opacity-50 disabled:bg-black"
                style="border-radius: 20px; width: 180px;"
                @click="showPreview(false)"
              >
                <div class="flex flex-row items-center justify-center">
                  <edit-circle-icn
                    width="20"
                    height="20"
                    class="mr-1"
                  ></edit-circle-icn>
                  <back-arrow-icn
                    width="20"
                    height="20"
                    class="mt-0.5 mr-0.5"
                  ></back-arrow-icn>
                  <span class="text-green text-lg font-bold leading-tight">
                    作成に戻る
                  </span>
                </div>
              </button>
            </div>
            <!-- 議員入力画面 -->
            <div v-else>
              <AppShowPreviewBtn
                color="green"
                colorcode="#549A1D"
                @click="validate"
                v-if="
                  currentReceipt.option.viewType == 1 ||
                    currentReceipt.option.viewType == 3
                "
              />
              <AppTempSaveBtn
                v-if="
                  currentReceipt.option.viewType == 1 ||
                    currentReceipt.option.viewType == 3
                "
                @click="
                  submitReceipt(
                    currentReceipt.id ? currentReceipt.id : null,
                    'receipt',
                  )
                "
                color="green"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </app-dialog>
</template>

<script>
import { onMounted, ref } from 'vue'
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from '@headlessui/vue'
import { useReceiptDialog } from '@/services/receiptsToda/useReceiptDialog'

import { useReceipts } from '@/services/receiptsToda/useReceipts'
import { useDialog } from '@/services/useDialog'
import { useReceiptReject } from '@/services/receiptsToda/useReceiptReject'

import AppDialog from '@/components/ui/AppDialog'
import AppReceiptStatusButton from '@/components/ui/AppReceiptStatusButton'
import AppApplyBtn from '@/components/ui/AppApplyBtn'
import AppShowPreviewBtn from '@/components/ui/AppShowPreviewBtn'
import AppTempSaveBtn from '@/components/ui/AppTempSaveBtn'
import AppApproveBtn from '@/components/ui/AppApproveBtn'
import AppApprovedBtn from '@/components/ui/AppApprovedBtn'
import AppCancelBtn from '@/components/ui/AppCancelBtn'
import AppWaitingBtn from '@/components/ui/AppWaitingBtn'
import AppRejectBtn from '@/components/ui/AppRejectBtn'
import AppApproveStateBtn from '@/components/ui/AppApproveStateBtn'
import AppRejectDisabledBtn from '@/components/ui/AppRejectDisabledBtn'
import AppShowOfficeBtn from '@/components/ui/AppShowOfficeBtn'
import AppReceiptShowFormBtn from '@/components/ui/AppReceiptShowFormBtn'
import ReceiptFormNavigation from '@/components/layout/receiptsToda/ReceiptFormNavigation'
import ReceiptForm from './ReceiptForm.vue'
import ReceiptPreview from './ReceiptPreview.vue'

import UserCircleIcn from '@/assets/icons/user-circle.svg?inline'
import ReceiptIcn from '@/assets/icons/receipt.svg?inline'
import ReceiptOffice from '@/components/layout/receiptsToda/ReceiptOffice'
import { useCurrentUser } from '@/services/useCurrentUser'
import { useReceiptForm } from '@/services/receiptsToda/useReceiptForm'
import BackArrowIcn from '@/assets/icons/back-arrow.svg?inline'

export default {
  name: 'ReceiptDialog_TODA',

  components: {
    AppApplyBtn,
    AppDialog,
    AppReceiptStatusButton,
    AppShowPreviewBtn,
    AppTempSaveBtn,
    AppApproveBtn,
    AppApprovedBtn,
    AppCancelBtn,
    AppWaitingBtn,
    AppRejectBtn,
    AppApproveStateBtn,
    AppRejectDisabledBtn,
    AppShowOfficeBtn,
    AppReceiptShowFormBtn,
    ReceiptIcn,
    ReceiptFormNavigation,
    UserCircleIcn,
    TabGroup,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    ReceiptForm,
    ReceiptPreview,

    ReceiptOffice,
    BackArrowIcn,
  },

  setup() {
    // TODO: destroy時の初期化
    const isActive = ref(false)
    const isMaxArea = ref(false)

    const { showPreview } = useReceiptDialog()
    const { currentUser } = useCurrentUser()
    const { resetRejectedItems } = useReceiptReject()
    onMounted(() => {
      resetRejectedItems()
      useReceiptDialog.isPreview = false
    })
    const validate = () => {
      const a = document.getElementById('receipt-validate-toda')
      a.click()
    }

    return {
      isActive,
      showPreview,
      currentUser,
      isMaxArea,
      resetRejectedItems,
      validate,
      ...useDialog(),
      ...useReceiptDialog(),
      ...useReceipts(),
      ...useReceiptForm(),
      ...useReceiptReject(),
    }
  },
}
</script>
<style lang="scss" scoped>
// .size-min {
//   height: 45px;
// }
// .size-max {
//   height: calc(100% - 75px);
// }
// .size-even {
//   height: calc((100% - 31px) / 2);
// }
</style>
